import { useSelector } from "react-redux";
import { selectUser } from "modules/auth/redux/selectors";
import { UserFeatures } from "services/splitService/features";
import { selectBrowserName } from "modules/systemCheck/redux/selectors";
import { useMemo } from "react";
import { useTreatment } from "../hooks/useTreatment";
import { TreatmentResponse } from "../types";
import { TrafficType } from "../constants";

const useUserSplitTreatment = (feature: UserFeatures): TreatmentResponse => {
  const user = useSelector(selectUser);
  const browserName = useSelector(selectBrowserName);
  const email = user?.email ?? "";
  const browser = browserName.toLowerCase();
  const key = user?.id ?? "";
  const attributes = useMemo(
    () => ({
      email,
      browser,
    }),
    [email, browser],
  );
  const treatment = useTreatment({
    feature,
    attributes,
    trafficType: TrafficType.USER,
    key,
  });

  return treatment;
};

export default useUserSplitTreatment;
